import { render, staticRenderFns } from "./recompra.vue?vue&type=template&id=2f592114"
import script from "./recompra.vue?vue&type=script&lang=js"
export * from "./recompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports